// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"2db5de3d","395":"61337a85","584":"10514440","761":"11ad5135"}[chunkId] + ".chunk.js";
};